/**
 * Consent types (owner, 2026-09-21; migration 0049). The programme's own steps first - a farmer
 * consents to each separately - then the platform-level ones. The ids are the CHECK values.
 */
export const CONSENT_TYPES = [
  { id: 'membership', label: 'Membership' },
  { id: 'plot_enrolment', label: 'Plot enrolment' },
  { id: 'harvest_request', label: 'Harvest request' },
  { id: 'harvest_sale', label: 'Harvest sale' },
  { id: 'payment', label: 'Payment' },
  { id: 'data_processing', label: 'Data processing' },
  { id: 'trading', label: 'Trading' },
  { id: 'document_share', label: 'Document sharing' },
  { id: 'representative', label: 'Representative' },
  { id: 'portal_access', label: 'Portal access' },
  { id: 'eudr_fsc_claim', label: 'EUDR / FSC claim' },
  // Issued by the withdrawal register, not by hand (migration 0066).
  { id: 'withdrawal', label: 'Withdrawal' },
];

export function consentTypeLabel(id?: string | null): string {
  if (!id) return '--';
  return CONSENT_TYPES.find((entry) => entry.id === id)?.label ?? id.replace(/_/g, ' ');
}
